const LightboxHeader = ({setLightboxIsOpen}) => {

  return <div className={'flex flex-row justify-end p-10'}>
    <svg
        onClick={() => setLightboxIsOpen(false)}
        className="w-10 h-10 text-white cursor-pointer" fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"/>
    </svg>
  </div>;

};

export default LightboxHeader;